<mat-card>
  <img src="{{imgLogo}}" alt="logoExplorandes" />
  <mat-card-content>
    <form [formGroup]="loginForm" (ngSubmit)="submit()">
      <!-- <h2>Log In</h2> -->
      <mat-error *ngIf="!loginValid">
        The username and password were not recognized
      </mat-error>
      <mat-form-field>
        <input matInput placeholder="Email" formControlName="username" name="username" required>
        <mat-error>
          Please provide a valid email address
        </mat-error>
      </mat-form-field>
      <br>
      <mat-form-field>
        <input matInput type="password" placeholder="Password" formControlName="password" name="password" required>
        <mat-error>
          Please provide a valid password
        </mat-error>
      </mat-form-field>
      <br>
      <button mat-raised-button color="primary" [disabled]="!loginForm.valid">INGRESAR</button>
    </form>
  </mat-card-content>
</mat-card>

